module.exports = __webpack_public_path__ + "static/media/Logo Vertical.33a45650.png";